import { inEnum, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { AspectRatio } from "../../lib/dynamicscaler/AspectRatio.js";
import { StaticContentSizing } from "../../lib/dynamicscaler/ContentSizing.js";
import { isMediaFormatRawData, MediaFormatRawData } from "../MediaFormat.js";

/**
 * questo enumerativo continene tutti i tipi di container video gestiti dal sistema
 */
export enum VideoContainerType {
    PROGRESSIVE_MP4 = 0,
    DASH_MP4 = 1,
    HLS = 2,
    ADAPTIVE_DASH_H264 = 3,
    ADAPTIVE_HLS_H264 = 4,
    ADAPTIVE_DASH_VP9 = 5,
    SHORT_PROGRESSIVE_MP4 = 6,
    ADAPTIVE_DASH_H265 = 7,
    ADAPTIVE_HLS_H265 = 8
};

/**
 * stringa di specifica delle dimensioni o proporzioni del video
 * una VideoSizeSpecification può essere espressa nei seguenti modi:
 * * dimensioni statiche: 640x360
 * * proporizioni: 16:9
 */
export type VideoSizeSpecification = string;


const sizeSpecRegex = /([1-9][0-9]*)(x|:)([1-9][0-9]*)/;

export function validateVideoSizeSpecificationString(str: string): boolean {
    return str && !!str.match(sizeSpecRegex);
};

export function isVideoSizeSpecification(any: any): any is VideoSizeSpecification {
    return isString(any) && validateVideoSizeSpecificationString(any);
};

export function parseSizeSpecification(v: string): StaticContentSizing | AspectRatio | null {

    if(v) {
        const matches = v.match(sizeSpecRegex);
        if(matches) {
            const w = parseInt(matches[1]);
            const h = parseInt(matches[3]);
            if(matches[2] == ':') {
                return new AspectRatio(w,h);
            }
            else {
                return new StaticContentSizing(w,h)
            }
        }
        else return null;
    }
    else return null;
};

/**
 * dati grezzi (provenienti da server) con le informazioni di formato del video
 */
export interface VideoFormatRawData extends MediaFormatRawData {

    container: VideoContainerType,
    size: VideoSizeSpecification,
    
};


/**
 * barrier per oggetti di tipo VideoFormatRawData
 * @param obj l'oggetto da verificare
 * @returns 
 */
export function isVideoFormatRawData(obj: any): obj is VideoFormatRawData {
    return isMediaFormatRawData(obj) &&
        inEnum(obj['container'],VideoContainerType) &&
        hasOwnProperty(obj,'size') &&
        isVideoSizeSpecification(obj['size']);
};
